import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import Heading from '../../../generic-components/Heading';
import TooltipWithTriangle from '../../../generic-components/TooltipWithTriangle';
import { ReactComponent as IconToolTipQuestion } from '../../../assets/svg/shared/icon-tooltip-question.svg';
import { ReactComponent as CloseIcon } from '../../../assets/svg/shared/icon-close.svg';

const STYLES = {
  WRAPPER: 'flex items-center px-[16px] border-t-[1px] border-bw03 h-[54px] rounded-b-[8px]',
  TOOL_TIP_CONTAINER:
    'absolute translate-x-[86%] translate-y-[-90%] top-0 right-0 flex flex-col justify-center mt-[-20px]',
  TOOL_TIP_CONTENT:
    'relative w-[286px] h-[90px] w-full font-metricR text-bw07 rounded-md py-[12px] px-[16px] bg-bw00 border border-bw05',
  TOOL_TIP_TRIANGLE: 'mt-[-10px] ml-[20px] z-0',
  TOOL_TIP_TRIANGLE_CLASS: 'triangle-FFFFFF',
  TOOL_TIP_HEAD: 'font-metricRMedium text-md text-bw08 mb-[5px] leading-5',
  TOOL_TIP_DESC: 'font-metricR text-md text-bw07 z-100 leading-5',
  TRANSFER_FEE: 'ml-auto font-metricR text-bw07 text-[14px]',
  QUESTION_ICON: 'w-[20px] h-[20px] hover:cursor-pointer',
  CLOSE_ICON_WRAPPER: 'cursor-pointer z-10 absolute right-[8px] top-[8px] w-[18px] h-[18px]',
  CLOSE_ICON: 'rounded-full fill-bw07 hover:bg-bw02',
};

interface ITransferFeeProps {
  transferFee: string;
  feeDescription?: string;
}

const TransferFee = ({ transferFee, feeDescription }: ITransferFeeProps) => {
  const { t } = useTranslation();
  const [isToolTipShown, setIsToolTipShown] = useState<boolean>(false);
  const handleCloseTooltip = (e: React.MouseEvent<HTMLElement>) => {
    e.stopPropagation();
    setIsToolTipShown(false);
  };
  return (
    <div className={STYLES.WRAPPER}>
      <Heading title={t('ACH_OUT_REVIEW.TRANSFER.FEE')} className='mr-[4px] font-metricR text-bw07 text-[14px]' />
      <div onClick={() => setIsToolTipShown(true)} className='relative' role='button' tabIndex={0} onKeyDown={() => {}}>
        {isToolTipShown && (
          <TooltipWithTriangle
            tooltipContainerClassName={STYLES.TOOL_TIP_CONTAINER}
            tooltipContentClassName={STYLES.TOOL_TIP_CONTENT}
            triangleClassName={STYLES.TOOL_TIP_TRIANGLE}
            triangleClass={STYLES.TOOL_TIP_TRIANGLE_CLASS}
          >
            <Heading title={t('ACH_OUT_REVIEW.TRANSFER.FEE_TOOL_TIP')} className={STYLES.TOOL_TIP_HEAD} />
            {feeDescription && <p className={STYLES.TOOL_TIP_DESC}>{feeDescription}</p>}
            <div
              className={STYLES.CLOSE_ICON_WRAPPER}
              data-testid='TransferFee__tooltip-close-btn'
              onClick={handleCloseTooltip}
              onKeyDown={() => {}}
              aria-label='close'
              role='button'
              tabIndex={0}
            >
              <CloseIcon className={STYLES.CLOSE_ICON} />
            </div>
          </TooltipWithTriangle>
        )}
        <IconToolTipQuestion data-testid='ACH_OUT_REVIEW_FEE_TOOLTIP_ICON' className={STYLES.QUESTION_ICON} />
      </div>
      <Heading title={`${transferFee}`} className={STYLES.TRANSFER_FEE} />
    </div>
  );
};

export default TransferFee;
